import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Label,
  Spinner,
} from "reactstrap";

import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";

import { postSubmitForm } from "../../../helpers/forms_helper";
import printDiv from "../../../helpers/print_data";
import { GetUpdatedDelivered, ExportAvailableInCSVForReports, formatUnitsForReport, convertToLowestUnit } from "../../../helpers/units";
import showNotification from "../../../helpers/show_notification";
import UpdateQuantityModal from "../../../components/UpdateQuantityModal";
import WithdrawModal from "../WithdrawModal";

const ItemClosing = (props) => {
  const { SearchBar } = Search;
  const [closingDate, setClosingDate] = useState();
  const [editFreeunitModal, setEditFreeunitModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState()
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const itemsRequestId = useRef(0);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    setClosingDate(formatDate(currentDay));
  }, []);

  useEffect(() => {
    if (closingDate) loadItemsForClosing();
  }, [closingDate]);
  const [itemsToClosed, setItemsToClosed] = useState([])
  const [isClosureDone, setIsClosureDone] = useState();
  const loadItemsForClosing = async () => {
    if (!closingDate) return;
    const requestId = ++itemsRequestId.current;
    try {
      setIsLoadingItems(true);
      let url = process.env.REACT_APP_BASEURL + "branchitems/get_for_closure";
      let data_to_send = {
        date_of_closure: closingDate,
      };

      const response = await postSubmitForm(url, data_to_send);
      if (requestId !== itemsRequestId.current) return;
      if (response && response.status === 1) {
        setItemsToClosed((prev) => {
          const currentRemarks = {};
          prev.forEach((item) => {
            if (item.remarks) {
              currentRemarks[item._id] = item.remarks;
            }
          });
          return (response.data || []).map((item) => ({
            ...item,
            available_to_compare: item.available,
            used: (item.used || []).map((obj, index) => ({
              index,
              unit: obj.unit,
              value: obj.value,
              isChecked: true,
            })),
            waste: (item.waste || []).map((obj, index) => ({
              index,
              unit: obj.unit,
              value: obj.value,
              isChecked: true,
            })),
            balance_in_hand: (item.balance_in_hand || []).map((obj, index) => ({
              index,
              unit: obj.unit,
              value: obj.value,
              isChecked: true,
            })),
            remarks: currentRemarks[item._id] || item.remarks || "",
          }));
        });
        setIsClosureDone(response.is_closure_done);
        setTablePage(1);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      if (requestId !== itemsRequestId.current) return;
      showNotification(error, "Error");
    } finally {
      if (requestId === itemsRequestId.current) {
        setIsLoadingItems(false);
      }
    }
  };
  function getFieldName (row,flag) {
    let field = "";
    switch (flag){
      case "used" :
      field = row.used;
      break;
      case "balance_in_hand" :
      field = row.balance_in_hand;
      break;
      case "waste" :
      field = row.waste;
      break;
    }
    return formatUnitsForReport(field,row.unit_levels);
  }
  const [heading, setHeading] = useState("")
  function getUnitsToFill (row,flag) {
    let field = "";
    switch (flag){
      case "used" :
      field = row.used;
      break;
      case "balance_in_hand" :
      field = row.balance_in_hand;
      break;
      case "waste" :
      field = row.waste;
      break;
    }
    const updatedItem = {...row,quantity: field}
    return setSelectedItem(updatedItem)
  }

  const handleColumnClick = async(row,flag) => {
    if(isClosureDone) return
    await getUnitsToFill(row,flag);
    setHeading(flag);
    setEditFreeunitModal(true)
  };

  const fontSmall = { fontSize: "11px" };
  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return (tablePage - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "2%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      formatter: (cell, row) =>
        `${row.name} (${row.category} - ${row.sub_category})`,
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Balance"),
      sort: true,
      editable: false,
      formatter: (cell, row) => { return formatUnitsForReport(row.available,row.unit_levels) },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "discarded",
      text: props.t("Expired"),
      sort: true,
      editable: false,
      formatter: (cell, row) => { return formatUnitsForReport(row.discard,row.unit_levels) },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "used",
      text: props.t("Used"),
      formatter: (cell,row)=>{
        return (
          getFieldName(row,"used")
        )
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          // console.log(1);
          handleViewDetailsClick(row,column)
          // handleColumnClick(row, column.dataField,"used");
        }},
      sort: true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Only numbers are allowed.",
          };
        }
        if (newValue % 1 != 0) {
          return {
            valid: false,
            message: "Decimals not allowed.",
          };
        }
        return true;
      },
      editable: false,
      attrs: (cell, row, rowIndex, colIndex) => {
        return isClosureDone ? {} : { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return isClosureDone
          ? {}
          : { cursor: "pointer", background: "#ffffaa" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "balance_in_hand",
      text: "Balance (in hand)",
      formatter: (cell,row)=>{
        return (
          getFieldName(row,"balance_in_hand")
        )
      },
      // events: {
      //   onClick: (e, column, columnIndex, row, rowIndex) => {
      //     handleColumnClick(row, column.dataField,"balance_in_hand");
      //   }},
      headerFormatter: () => {
        return (
          <span>
            Balance
            <br />
            <span style={fontSmall}>(in hand)</span>
          </span>
        );
      },
      sort: true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Only numbers are allowed.",
          };
        }
        if (newValue % 1 != 0) {
          return {
            valid: false,
            message: "Decimals not allowed.",
          };
        }
        return true;
      },
      editable:false,
      attrs: (cell, row, rowIndex, colIndex) => {
        return isClosureDone ? {} : { title: "Click to Edit" };
      },
      // style: (cell, row, rowIndex, colIndex) => {
      //   return isClosureDone
      //     ? {}
      //     : { cursor: "pointer", background: "#aae6ff" };
      // },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "waste",
      text: "Waste",
      formatter: (cell,row)=>{
        return (
          getFieldName(row,"waste")
        )
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {          
           handleViewDetailsClick(row,column)
          // handleColumnClick(row, column.dataField,"waste");
        }},
      sort: true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Only numbers are allowed.",
          };
        }
        if (newValue % 1 != 0) {
          return {
            valid: false,
            message: "Decimals not allowed.",
          };
        }
        return true;
      },
      editable: false,
      attrs: (cell, row, rowIndex, colIndex) => {
        return isClosureDone ? {} : { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return isClosureDone
          ? {}
          : { cursor: "pointer", background: "#ffaaaa" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      sort: true,
      editable: isClosureDone ? false : true,
      attrs: (cell, row, rowIndex, colIndex) => {
        return isClosureDone ? {} : { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return isClosureDone
          ? {}
          : { cursor: "pointer", background: "#ffffaa" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };
  function checkRemarks(items) {
    let remarkRequired = false;
    for (let i = 0; i < items.length; i++) {
        const wasteArray = items[i].waste;
        if (wasteArray.length > 0 && wasteArray.some(w => w.value !== 0) && items[i].remarks==="") {
            remarkRequired = true;
            break; 
        }
    }
    return remarkRequired
  }
  const formatQuantity = (qty, unitLevels) => {
    const formatted = GetUpdatedDelivered([{unit: unitLevels[unitLevels.length - 1].unit, value: qty}], unitLevels);
    return formatted.map(item => `${item.value} ${item.unit}`).join(' ');
  };
  const validateItemClosure = (item) => {
    try {
      const balanceQty = convertToLowestUnit(item.unit_levels, item.balance_in_hand || []);
      const usedQty = convertToLowestUnit(item.unit_levels, item.used || []);
      const wasteQty = convertToLowestUnit(item.unit_levels, item.waste || []);
      
      const usedToCompare = convertToLowestUnit(item.unit_levels, item.used_to_compare || []);
      const balanceToCompare = convertToLowestUnit(item.unit_levels, item.available_to_compare || []);
      const wasteToCompare = convertToLowestUnit(item.unit_levels, item.waste_to_compare || []);
  
      const usedDifference = usedQty - usedToCompare;
      const wasteDifference = wasteQty - wasteToCompare;
      
      const expectedBalance = balanceToCompare - usedDifference - wasteDifference;
  
      if (balanceQty !== expectedBalance) {
        return {
          isValid: false,
          message: `<strong>${item.name}</strong>: Balance quantity 
            <strong>(${formatQuantity(balanceQty, item.unit_levels)})</strong> 
            should be <strong>(${formatQuantity(expectedBalance, item.unit_levels)})</strong>
            [Original Balance(${formatQuantity(balanceToCompare, item.unit_levels)}) - 
            Used Difference(${formatQuantity(usedDifference, item.unit_levels)}) - 
            Waste Difference(${formatQuantity(wasteDifference, item.unit_levels)})]`
        };
      }
  
      if (expectedBalance < 0) {
        return {
          isValid: false,
          message: `<strong>${item.name}</strong>: Changes would result in negative balance
            <strong>(${formatQuantity(expectedBalance, item.unit_levels)})</strong>`
        };
      }
  
      return { 
        isValid: true,
        usedQty,
        balanceQty,
        wasteQty,
        expectedBalance,
        usedDifference,
        wasteDifference
      };
  
    } catch (error) {
      console.error('Error in validateItemClosure:', error);
      return {
        isValid: false,
        message: `<strong>${item.name}</strong>: Error validating quantities.`
      };
    }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmitClosure = async (e, v) => {
    try {
      let isValid = true;

    if(checkRemarks((itemsToClosed))){
      showNotification("Enter remarks for all wasted items.", "Warning");
      return
    } 

    for (const item of itemsToClosed) {
      const validationResult = validateItemClosure(item);
      if (!validationResult.isValid) {
        isValid = false;
        showNotification(validationResult.message,"Warning");
        return
      }
    }
    if(isValid){
      const object = {
        date_of_closure: closingDate,
        closure_details: itemsToClosed.map((obj)=>({
         ...obj,
          waste:obj.waste.map(({unit,value})=>({unit,value:+value})),
          used:obj.used.map(({unit,value})=>({unit,value:+value})),
          balance_in_hand:obj.balance_in_hand.map(({unit,value})=>({unit,value:+value})),
          }
        )),
      };
      setIsSubmitting(true);
      let url = process.env.REACT_APP_BASEURL + "branchitemclosures/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadItemsForClosing();
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    }
      
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleDownload = async () => {
    const fileName = "item_closure";
    const exportType = "xls";
    let data_to_export = itemsToClosed;
    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          Category: v.category,
          SubCategory: v.category,
          Balance: ExportAvailableInCSVForReports(v.balance_in_hand),
          Expired: ExportAvailableInCSVForReports(v.discarded),
          Used: ExportAvailableInCSVForReports(v.used),
          Waste:ExportAvailableInCSVForReports(v.waste),
          Remarks: v.remarks,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };
  function handleCloseModal (){
    setEditFreeunitModal(false)
    setSelectedItem()
  }
  const handleAddUnits = (quantity) => {
    const enteredQty = convertToLowestUnit(selectedItem.unit_levels, quantity);
    // const availableQty = convertToLowestUnit(selectedItem.unit_levels, selectedItem.available_to_compare || []);
    const currentUsed = convertToLowestUnit(selectedItem.unit_levels, selectedItem.used || []);
    const currentWaste = convertToLowestUnit(selectedItem.unit_levels, selectedItem.waste || []);
    // const currentBalance = convertToLowestUnit(selectedItem.unit_levels, selectedItem.balance_in_hand || []);

    const balanceToCompare = convertToLowestUnit(selectedItem.unit_levels, selectedItem.available_to_compare || []);
    const usedToCompare = convertToLowestUnit(selectedItem.unit_levels, selectedItem.used_to_compare || []);
    const wasteToCompare = convertToLowestUnit(selectedItem.unit_levels, selectedItem.waste_to_compare || []);

    const usedDifference = currentUsed - usedToCompare;
    const wasteDifference = currentWaste - wasteToCompare;
    const effectiveBalance = balanceToCompare - usedDifference - wasteDifference;

    switch(heading) {
      case 'used':
        const newUsedDiff = enteredQty - usedToCompare;
        const remainingAfterUsed = balanceToCompare - newUsedDiff - wasteDifference;
        
        if (remainingAfterUsed < 0) {
          showNotification(
            `${selectedItem.name}: Cannot use ${formatQuantity(enteredQty, selectedItem.unit_levels)} units. 
            Maximum available is ${formatQuantity(balanceToCompare - wasteDifference + usedToCompare, selectedItem.unit_levels)}
            considering current waste of ${formatQuantity(currentWaste, selectedItem.unit_levels)}`,
            "Warning"
          );
          return;
        }
        break;

      case 'waste':
        const newWasteDiff = enteredQty - wasteToCompare;
        const remainingAfterWaste = effectiveBalance - newWasteDiff;
        
        if (remainingAfterWaste < 0) {
          showNotification(
            `${selectedItem.name}: Cannot waste ${formatQuantity(enteredQty, selectedItem.unit_levels)} units. 
            Maximum available is ${formatQuantity(effectiveBalance + wasteToCompare, selectedItem.unit_levels)}
            considering current used quantity of ${formatQuantity(currentUsed, selectedItem.unit_levels)}`,
            "Warning"
          );
          return;
        }
        break;

      case 'balance_in_hand':
        if (enteredQty !== effectiveBalance) {
          showNotification(
            `${selectedItem.name}: Balance must be ${formatQuantity(effectiveBalance, selectedItem.unit_levels)} 
            based on current used (${formatQuantity(currentUsed, selectedItem.unit_levels)}) and 
            waste (${formatQuantity(currentWaste, selectedItem.unit_levels)}) quantities`,
            "Warning"
          );
          return;
        }
        break;

      default:
        throw new Error('Invalid heading');
    }

    const ConvertedEnteredQty= GetUpdatedDelivered(quantity, selectedItem.unit_levels);
      const updatedItem = {...selectedItem,[heading]: ConvertedEnteredQty};
      const updatedItemsToClosed = itemsToClosed.map(item => 
        item._id === selectedItem._id ? updatedItem : item
      );
      setItemsToClosed(updatedItemsToClosed);
      setEditFreeunitModal(false);
      setSelectedItem([]);

  };
  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedItem_Transactions, setSelectedItem_Transactions] = useState([]);
  const handleViewDetailsClick = async (row,column) => {
   try {
     if(isClosureDone) return
     let url = process.env.REACT_APP_BASEURL + "branchiteminventories/get_by_item_id";
    const response = await postSubmitForm(url, {
      item_id: row.value,
      inventory_type: "Kitchen",
    });
    if (response && response.status === 1) {
      setSelectedItem_Transactions(response.data);
      setSelectedItem((prev)=>({...row,column:column.dataField}));
      setTransactionsModal(true);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.log(error);
   }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item Closing")}
            title={props.t("Closing")}
            breadcrumbItem1={props.t("Items")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleSubmitClosure}>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="closing_date"
                          label={props.t("Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={closingDate}
                          onChange={(e, v) => {
                            setClosingDate(formatDate(e.target.value));
                          }}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{
                            required: { value: true },
                          }}
                        />
                      </Col>
                      <Col lg={6}>
                        {isClosureDone && isClosureDone ? (
                          <>
                            {" "}
                            <Label>&nbsp;</Label> <br />
                            <p style={{ color: "green" }}>
                              {props.t("Closure done for selected date.")}
                            </p>
                          </>
                        ) : (
                          <>
                            <Label>&nbsp;</Label> <br />
                            <Button
                              type="submit"
                              color="primary"
                              className="w-50"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? <Spinner size="sm"/> : props.t("Submit Closure")}
                            </Button>{" "}
                          </>
                        )}
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>{" "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="item_id"
                      data={itemsToClosed || []}
                      columns={columns}
                      search
                      exportCSV
                    >
                      {(tprops) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...tprops.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}><CardTitle className="text-center">
                      {props.t("Item Closure")}
                    </CardTitle></Col>
                            <Col lg={4} className="text-right"></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            cellEdit={cellEditFactory({
                              mode: "click",
                              blurToSave: true,
                              afterSaveCell: async (
                                oldValue,
                                newValue,
                                row,
                                column
                              ) => {
                                // tableCellAfterSave(
                                //   oldValue,
                                //   newValue,
                                //   row,
                                //   column
                                // );
                              },
                            })}
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingItems ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...tprops.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
                    <WithdrawModal
                    isOpen={transactionsModal}
                    transactionsModal={transactionsModal}
                    setTransactionsModal={setTransactionsModal}
                      toggle={()=>setTransactionsModal(false)}
                      selectedItem={selectedItem}
                      transactions={selectedItem_Transactions}
                      isItem={true}
                      handleViewDetailsClick={handleViewDetailsClick}
                      loadData={loadItemsForClosing}
                    />


          {/* Add Quantity modal  */}
          <UpdateQuantityModal
            isOpen={editFreeunitModal}
            toggle={handleCloseModal}
            onSubmit={handleAddUnits}
            item={selectedItem}
            closure={true}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemClosing))
);
